"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./adminprofile.interface"), exports);
__exportStar(require("./agentprofile.interface"), exports);
__exportStar(require("./ai_assistant.interface"), exports);
__exportStar(require("./ai_request.interface"), exports);
__exportStar(require("./api_key.interface"), exports);
__exportStar(require("./audit.interface"), exports);
__exportStar(require("./canned_answer.interface"), exports);
__exportStar(require("./chat.configuration.interface"), exports);
__exportStar(require("./client.interface"), exports);
__exportStar(require("./contact.interface"), exports);
__exportStar(require("./contact_custom_event.interface"), exports);
__exportStar(require("./conversation.interface"), exports);
__exportStar(require("./conversation_favourite.interface"), exports);
__exportStar(require("./conversation_filter.interface"), exports);
__exportStar(require("./conversation_watcher.interface"), exports);
__exportStar(require("./destination_restrictor.interface"), exports);
__exportStar(require("./disposition.interface"), exports);
__exportStar(require("./draft.interface"), exports);
__exportStar(require("./field.interface"), exports);
__exportStar(require("./form.interface"), exports);
__exportStar(require("./form_submission.interface"), exports);
__exportStar(require("./form_website.interface"), exports);
__exportStar(require("./gdpr.interface"), exports);
__exportStar(require("./gdpr_anonymize.interface"), exports);
__exportStar(require("./internal_note.interface"), exports);
__exportStar(require("./invoice.interface"), exports);
__exportStar(require("./invoice_post.interface"), exports);
__exportStar(require("./journey.interface"), exports);
__exportStar(require("./journey_draft.interface"), exports);
__exportStar(require("./journey_trigger.interface"), exports);
__exportStar(require("./journey_variable.interface"), exports);
__exportStar(require("./list.interface"), exports);
__exportStar(require("./list_file.interface"), exports);
__exportStar(require("./mail_account.interface"), exports);
__exportStar(require("./mail_message.interface"), exports);
__exportStar(require("./notification.interface"), exports);
__exportStar(require("./notification_user.interface"), exports);
__exportStar(require("./operational_hours.interface"), exports);
__exportStar(require("./organization.interface"), exports);
__exportStar(require("./pause.interface"), exports);
__exportStar(require("./phonenumber_monthly_cost.interface"), exports);
__exportStar(require("./phonenumber_monthly_cost_parent.interface"), exports);
__exportStar(require("./phonenumber_prefix.interface"), exports);
__exportStar(require("./phonenumber_purchase.interface"), exports);
__exportStar(require("./phonenumber_setup_cost.interface"), exports);
__exportStar(require("./phonenumber_setup_cost_parent.interface"), exports);
__exportStar(require("./phonenumber_stock.interface"), exports);
__exportStar(require("./points_system.interface"), exports);
__exportStar(require("./prepaid_credit.interface"), exports);
__exportStar(require("./queue.interface"), exports);
__exportStar(require("./recently_searched.interface"), exports);
__exportStar(require("./recently_viewed_conversation.interface"), exports);
__exportStar(require("./release.interface"), exports);
__exportStar(require("./session.interface"), exports);
__exportStar(require("./signature.interface"), exports);
__exportStar(require("./skill.interface"), exports);
__exportStar(require("./sla_policy.interface"), exports);
__exportStar(require("./sound.interface"), exports);
__exportStar(require("./stats_alarm.interface"), exports);
__exportStar(require("./stats_custom_metric.interface"), exports);
__exportStar(require("./stats_report.interface"), exports);
__exportStar(require("./stats_report_preview_widget.interface"), exports);
__exportStar(require("./stats_report_widget.interface"), exports);
__exportStar(require("./stats_widget.interface"), exports);
__exportStar(require("./superadmin_profile.interface"), exports);
__exportStar(require("./tab.interface"), exports);
__exportStar(require("./tag.interface"), exports);
__exportStar(require("./tariff.interface"), exports);
__exportStar(require("./tariff_parent.interface"), exports);
__exportStar(require("./team.interface"), exports);
__exportStar(require("./time_interval.interface"), exports);
__exportStar(require("./user.interface"), exports);
__exportStar(require("./user_activity.interface"), exports);
__exportStar(require("./user_status.interface"), exports);
__exportStar(require("./voice_asterisk.interface"), exports);
__exportStar(require("./voice_asterisk_downgrade.interface"), exports);
__exportStar(require("./voice_asterisk_operational_hours.interface"), exports);
__exportStar(require("./voice_asterisk_toggle_history.interface"), exports);
__exportStar(require("./voice_call.interface"), exports);
__exportStar(require("./voice_call_bridge.interface"), exports);
__exportStar(require("./voice_chanspy.interface"), exports);
__exportStar(require("./voice_chanspy_call.interface"), exports);
__exportStar(require("./voice_internal_call.interface"), exports);
__exportStar(require("./voice_recording.interface"), exports);
__exportStar(require("./voice_recording_transcript.interface"), exports);
__exportStar(require("./voice_recording_transcript_setting.interface"), exports);
__exportStar(require("./voice_route.interface"), exports);
__exportStar(require("./voice_shortcut.interface"), exports);
__exportStar(require("./voice_trunk.interface"), exports);
__exportStar(require("./voice_voicemail.interface"), exports);
__exportStar(require("./voice_voicemail_message.interface"), exports);
__exportStar(require("./wallboard.interface"), exports);
__exportStar(require("./textMessageSourceInterface"), exports);
__exportStar(require("./textMessageInterface"), exports);
__exportStar(require("./textMessageSourceInterface"), exports);
